var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQuery = function SvgQuery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.678C7.6685 2.678 7.4 2.9465 7.4 3.278V8C7.4 8.2055 7.505 8.3965 7.6785 8.5065L10.6105 10.3665C10.71 10.4295 10.8215 10.4595 10.931 10.4595C11.13 10.4595 11.324 10.361 11.4385 10.181C11.616 9.901 11.533 9.5305 11.253 9.353L8.6 7.6695V3.278C8.6 2.9465 8.3315 2.678 8 2.678ZM16 8C16 12.411 12.411 16 8 16C3.5885 16 0 12.411 0 8C0 7.668 0.2685 7.3995 0.6 7.3995C0.931 7.3995 1.1995 7.668 1.1995 8C1.1995 11.7495 4.2505 14.7995 8 14.7995C11.7495 14.7995 14.8 11.7495 14.8 8C14.8 4.2505 11.7495 1.2 8 1.2C6.052 1.2 4.205 2.037 2.913 3.4935L4.3655 3.6455C4.6955 3.6795 4.9345 3.975 4.9 4.3045C4.868 4.6125 4.6075 4.842 4.304 4.842C4.283 4.842 4.262 4.841 4.241 4.8385L1.2825 4.5295C0.9535 4.4955 0.7145 4.2015 0.748 3.8725L1.0465 0.9285C1.08 0.5985 1.3735 0.361 1.704 0.392C2.0335 0.4255 2.274 0.72 2.24 1.0495L2.08 2.631C3.5965 0.9605 5.739 0 8 0C12.411 0 16 3.5885 16 8Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/query.81f277f5.svg";
export { ForwardRef as ReactComponent };